import script from "./CreateUserModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUserModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateUserModal.vue?vue&type=style&index=0&id=650e6e16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650e6e16"]])

export default __exports__